import React from 'react';
import {
    Container,
    Row,
    Col,
    TabsTab,
    TabsList,
    TabsV2,
    TabPanel,
    Callout,
    CalloutTitle,
    CalloutBody,
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuList,
    DropdownMenuLink,
} from '@si-armes/dsfr-react';
import { useSelector } from 'react-redux';
import Armes from './armes';
import Munitions from './munitions';
import RepriseDeDonneesArme from './armes/components/repriseDeDonnees/index';
import {
    DROITS_RATELIER_AJOUTER_UNE_ARME,
    ROLE_COLLECTIONNEUR,
    ROLE_CORRECTION_RATELIER_ARMES,
    ROLE_HERITIER,
    ROLE_METIER_ASSOCIATION,
    ROLE_METIER_ASSOCIATION_EMPLOYE,
    ROLE_TIREUR_SPORTIF,
} from '../../../utils/droitsEtRoles.constant';
import verifierDroits from '../../../components/VerifierDroits/verifierDroits.func';
import Historique from './historique';
import { getPath } from '../../../utils/router';
import RoutesDemandeArmeHeritee from '../armes/demande-arme-heritee/routes';
import RoutesDemandeArmeTrouvee from '../armes/demande-arme-trouvee/routes';
import RoutesImportArmeEnMasse from '../armes/import-arme-en-masse/routes';
import VerifierDroitsComponent from '../../../components/VerifierDroits/VerifierDroitsComponent';
import RoutesSignalerArmeManquante from '../armes/signaler-arme-manquante/routes';
import FeatureFlippingComponent from '../../../components/FeatureFlipping/FeatureFlippingComponent';
import { FEATURE_AUTORISATION_FONCTIONNALITES_COMPTE_DETENTEUR_HERITIER } from '../../../components/FeatureFlipping/featureFlipping.func';
import styles from './index.module.scss';
import { METIER_ASSOCIATION_MUSEE } from '../../../constants/metierAssociation.constants';
import { isMetier } from '../../../utils/Statuts.MetierAsso.constant';

const OngletCustom = (verifDroitTireurSportif) => {
    const onglets = [
        {
            titre: 'Mes armes',
            idAria: 'Mes-armes',
            onglet: <Armes />,
        },
    ];

    if (verifDroitTireurSportif.verifDroit) {
        onglets.push({
            titre: 'Mes munitions',
            idAria: 'Mes-munitions',
            onglet: <Munitions />,
        });
    }

    onglets.push({
        titre: 'Mon historique',
        idAria: 'Mon-historique',
        onglet: <Historique />,
    });

    return (
        <TabsV2>
            <TabsList label="choix du materiel" id="armes">
                {onglets.map((onglet) => {
                    return <TabsTab idTab={onglet.idAria}>{onglet.titre}</TabsTab>;
                })}
            </TabsList>
            {onglets.map((onglet) => {
                return <TabPanel idTab={onglet.idAria}>{onglet.onglet}</TabPanel>;
            })}
        </TabsV2>
    );
};

export const getArmeInfoCallout = (hasCorrectionRole, isCollectionneur = false) => {
    const getCalloutBody = () => {
        if (!hasCorrectionRole) {
            return (
                <p>
                    Vous trouverez ci-dessous les armes que vous possédez, identifiées par un n°
                    d'encodage.
                </p>
            );
        }

        if (isCollectionneur) {
            return (
                <p>
                    Vous trouverez ci-dessous les armes que vous possédez, identifiées par un n°
                    d'encodage. Vous disposez de six mois pour ajouter les armes que vous détenez
                    déjà en utilisant la fonctionnalité « Ajouter une arme ». Dans l'éventualité où
                    vous avez fait une erreur lors de l'ajout d'une arme, vous pouvez modifier les
                    informations incorrectes en utilisant la fonctionnalité « Signaler une erreur »
                    qui apparaît lorsque vous cochez une arme. Vous disposez de six mois pour
                    ajouter et corriger les informations présentes sur votre râtelier via les deux
                    fonctionnalités précitées. Passé ce délai, les boutons « Signaler une erreur »
                    et « Ajouter une arme » ne seront plus accessibles et vous devrez directement
                    faire la demande à votre Préfecture de rattachement.
                </p>
            );
        }

        return (
            <>
                <p>
                    Vous trouverez ci-dessous les armes que vous possédez, identifiées par un n°
                    d'encodage. Si les informations sont incorrectes, vous devez utiliser la
                    fonctionnalité «Signaler une erreur» qui apparaît lorsque vous cochez une arme.
                    Si des armes sont absentes du râtelier, utilisez la fonctionnalité «Ajouter une
                    arme».
                </p>
                <br />

                <p>
                    Vous disposez de 6 mois pour corriger les informations présentes sur votre
                    râtelier via les deux fonctionnalités précitées. Passé ce délai, les boutons
                    «Signaler une erreur» et «Ajouter une arme» ne seront plus accessibles et vous
                    devrez directement faire la demande à votre Préfecture de rattachement.
                </p>
            </>
        );
    };

    return (
        <Row gutters>
            <Col>
                <Callout icon="fr-fi-information-line" title="Titre mise en avant" titleAs="h2">
                    {hasCorrectionRole && !isCollectionneur && (
                        <CalloutTitle titleAs="h2" __TYPE="CalloutTitle">
                            Vérifiez les informations liées à vos armes
                        </CalloutTitle>
                    )}
                    <CalloutBody __TYPE="CalloutBody">{getCalloutBody()}</CalloutBody>
                </Callout>
            </Col>
        </Row>
    );
};

export const getAutorisationCallout = (isMetierSansAutorisationNiArmes) => {
    if (!isMetierSansAutorisationNiArmes) {
        return null;
    }

    return (
        <Row gutters>
            <Col>
                <Callout
                    icon="fr-fi-information-line"
                    title="Information autorisation"
                    titleAs="h2"
                >
                    <CalloutTitle titleAs="h2" __TYPE="CalloutTitle">
                        Mise à jour du nombre d'armes détenues dans le râtelier
                    </CalloutTitle>
                    <CalloutBody __TYPE="CalloutBody">
                        <>
                            <p>
                                Madame, Monsieur,
                                <br />
                                <br />
                                Dans le cadre de l'instruction de votre demande d'autorisation, nous
                                vous remercions de bien vouloir ajouter les armes détenues dans
                                votre râtelier, ce afin, que la préfecture puisse avoir en sa
                                possession l'information du nombre d'armes détenues et poursuivre
                                l'instruction de votre demande.
                                <br />
                                <br />
                                Nous vous remercions pour votre compréhension
                            </p>
                        </>
                    </CalloutBody>
                </Callout>
            </Col>
        </Row>
    );
};

const Ratelier = () => {
    const { data: dataArmes } = useSelector((state) => state.recherche.armes);
    const { data: dataProfil } = useSelector((state) => state.profil.usager);
    const userRoles = dataProfil ? Object.values(dataProfil)[3] || [] : [];
    const hasRoleCorrectionRatelierArmes = userRoles.includes(ROLE_CORRECTION_RATELIER_ARMES);
    const isCollectionneur = userRoles.includes(ROLE_COLLECTIONNEUR);
    const isMetierSansArmes =
        dataArmes &&
        isMetier(dataProfil?.sousStatut ?? '') &&
        (!dataArmes.nombreTotal || dataArmes.nombreTotal === 0);

    return (
        <Container fluid={false}>
            <Row gutters>
                <Col>
                    <h1 data-testid="ratelier-title">Mon râtelier numérique</h1>
                </Col>
            </Row>
            <>{getAutorisationCallout(isMetierSansArmes)}</>
            {/* Le ROLE_CORRECTION_RATELIER_ARMES est ajouté à la création d'un compte ou à l'ajout d'un persona */}
            {/* Il est ensuite, dans tous les cas, systématiquement supprimé 6 mois après. */}
            {userRoles.length > 0 && (
                <>{getArmeInfoCallout(hasRoleCorrectionRatelierArmes, isCollectionneur)}</>
            )}
            <RepriseDeDonneesArme />
            <div className={styles.containerDropdown}>
                <DropdownMenu id="dropdown-link" label="Ajouter une arme" size="md">
                    <DropdownMenuContent>
                        <DropdownMenuList>
                            {(hasRoleCorrectionRatelierArmes || isCollectionneur) && (
                                <li>
                                    {hasRoleCorrectionRatelierArmes ? (
                                        <>
                                            <VerifierDroitsComponent
                                                droits={DROITS_RATELIER_AJOUTER_UNE_ARME}
                                            >
                                                <DropdownMenuLink
                                                    href={getPath(RoutesSignalerArmeManquante)}
                                                >
                                                    Ajouter une arme
                                                </DropdownMenuLink>
                                            </VerifierDroitsComponent>

                                            {/* lorsque on supprime le feature FEATURE_AUTORISATION_FONCTIONNALITES_COMPTE_DETENTEUR_HERITIER, on combine le compsant VerifierDroitsComponent avec le précident en ajoutant le role ROLE_HERITIER */}
                                            <FeatureFlippingComponent
                                                featureName={
                                                    FEATURE_AUTORISATION_FONCTIONNALITES_COMPTE_DETENTEUR_HERITIER
                                                }
                                            >
                                                <VerifierDroitsComponent droits={[ROLE_HERITIER]}>
                                                    <DropdownMenuLink
                                                        href={getPath(RoutesSignalerArmeManquante)}
                                                    >
                                                        Ajouter une arme
                                                    </DropdownMenuLink>
                                                </VerifierDroitsComponent>
                                            </FeatureFlippingComponent>
                                        </>
                                    ) : (
                                        <DropdownMenuLink disabled>
                                            Ajouter une arme
                                        </DropdownMenuLink>
                                    )}
                                </li>
                            )}
                            <li>
                                <DropdownMenuLink href={getPath(RoutesDemandeArmeHeritee)}>
                                    Ajouter une arme héritée
                                </DropdownMenuLink>
                            </li>
                            <li>
                                <DropdownMenuLink href={getPath(RoutesDemandeArmeTrouvee)}>
                                    Ajouter une arme trouvée
                                </DropdownMenuLink>
                            </li>
                            {dataProfil?.sousStatut === METIER_ASSOCIATION_MUSEE && (
                                <li>
                                    <DropdownMenuLink href={getPath(RoutesImportArmeEnMasse)}>
                                        Ajouter des armes en masse
                                    </DropdownMenuLink>
                                </li>
                            )}
                        </DropdownMenuList>
                    </DropdownMenuContent>
                </DropdownMenu>
            </div>
            <OngletCustom
                verifDroit={
                    !isCollectionneur &&
                    verifierDroits(dataProfil, [
                        ROLE_TIREUR_SPORTIF,
                        ROLE_METIER_ASSOCIATION,
                        ROLE_METIER_ASSOCIATION_EMPLOYE,
                    ])
                }
            />
        </Container>
    );
};

export default Ratelier;
